import { createSelector } from "@ngrx/store";

import { IAppState } from "../state/app.state";
import { IConsumptionState } from "../state/consumption.state";

const consumptionSelector = (state: IAppState) => state.consumption;

export const getConsumptions = createSelector(consumptionSelector, (state: IConsumptionState) => state.consumptions.data);
export const getConsumptionsAPIError = createSelector(consumptionSelector, (state: IConsumptionState) => state.consumptions.lastAPIError);
export const getConsumptionChartData = createSelector(consumptionSelector, (state: IConsumptionState) => state.consumptions.chartData);
export const getConsumptionPeriod = createSelector(consumptionSelector, (state: IConsumptionState) => state.consumptions.period);
export const getConsumptionEvolution = createSelector(consumptionSelector, (state: IConsumptionState) => state.consumptionEvolution);
export const getConsumptionHistory = createSelector(
    consumptionSelector,
    (state: IConsumptionState) => state.consumptions.consumptionHistory
);
export const getMobieConsumptionHistory = createSelector(
    consumptionSelector,
    (state: IConsumptionState) => state.consumptions.mobieConsumptionHistory
);
export const getConsumptionSelected = createSelector(consumptionSelector, (state: IConsumptionState) => state.consumptionSelected);
export const getMobieCardList = createSelector(consumptionSelector, (state: IConsumptionState) => state.mobieCardList);
export const getActiveTab = createSelector(consumptionSelector, (state: IConsumptionState) => state.activeTab);
export const getMobieConsumptions = createSelector(consumptionSelector, (state: IConsumptionState) => state.mobieConsumptions);
